import Head from 'next/head';

// Generated with https://realfavicongenerator.net/
export default function Favicon() {
  return (
    <Head>
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/manifest.json" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#2a292e" />
      <meta name="msapplication-TileColor" content="#2a292e" />
      <meta name="theme-color" content="#ff0048" />
    </Head>
  );
}
